const LocationTypes = {
  Escuela: 135,
  Oficina_del_Proveedor: 136,
  CSEE: 137,
  Hogar: 482,
};

export default LocationTypes;
